import React from "react";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  open: "bg-stone-100 text-slate-700 border-stone-200",
  active: "bg-stone-100 text-slate-700 border-stone-200",
  online: "bg-stone-100 text-slate-700 border-stone-200",
  offline: "bg-stone-100 text-slate-600 border-stone-200",
  inactive: "bg-stone-100 text-slate-600 border-stone-200",
  pending: "bg-stone-100 text-slate-600 border-stone-200",
  acknowledged: "bg-stone-100 text-slate-700 border-stone-200",
  dispatched: "bg-stone-100 text-slate-700 border-stone-200",
  on_route: "bg-stone-100 text-slate-700 border-stone-200",
  on_scene: "bg-stone-100 text-slate-700 border-stone-200",
  completed: "bg-stone-100 text-slate-700 border-stone-200",
  alert: "bg-stone-100 text-slate-700 border-stone-200",
  warning: "bg-stone-100 text-slate-700 border-stone-200",
  idle: "bg-stone-100 text-slate-600 border-stone-200",
  incoming: "bg-stone-100 text-slate-700 border-stone-200",
  resolved: "bg-stone-100 text-slate-700 border-stone-200",
  closed: "bg-stone-100 text-slate-700 border-stone-200",
};

const LABEL = {
  on_route: "On the way",
  on_scene: "On scene",
};

export default function StatusBadge({ status = "pending", className }) {
  // Normalize status to a string safely. Some callers may pass objects.
  let _s = status;
  if (typeof _s !== "string") {
    if (_s && typeof _s === "object" && (_s.status || _s.state)) {
      _s = String(_s.status || _s.state);
    } else {
      _s = String(_s || "pending");
    }
  }
  const key = (_s || "pending").toLowerCase();
  const cls = STATUS_STYLES[key] || "bg-stone-100 text-slate-600 border-stone-200";
  const label = LABEL[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-wide",
        cls,
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {label}
    </span>
  );
}
